import React from "react";
import { Upload } from "antd";
import { CloseIcon, DragIcon, PlusIcon } from "assets/icons";
import "./style.scss";
import AlertNotification from "../alertNotification";

const { Dragger } = Upload;

function PhotoDragUpload({ fileList, setFileList }) {
  const beforeUpload = (file) => {
    const isImage = ["image/jpeg", "image/png", "image/jpg"].includes(
      file.type,
    );
    if (!isImage) {
      AlertNotification("error", "Only JPG/PNG/JPEG files are allowed!");
    }
    return isImage || Upload.LIST_IGNORE;
  };

  const handleRemove = (file) => {
    setFileList((prev) => prev.filter((item) => item.uid !== file.uid));
  };

  const handleChange = (info) => {
    const updated = info.fileList.map((file) => ({
      ...file,
      preview: URL.createObjectURL(file.originFileObj || file),
    }));
    setFileList(updated);
  };

  const handleClickAdd = () => {
    document.getElementById("hidden-upload").click();
  };

  const renderThumbnails = () => (
    <div className="photo-drag-uploader">
      {fileList.map((file) => (
        <div className="image-box" key={file.uid}>
          <img
            src={file.preview || URL.createObjectURL(file.originFileObj)}
            alt={file.name}
          />
          <span className="remove-btn" onClick={() => handleRemove(file)}>
            <CloseIcon />
          </span>
        </div>
      ))}
      {fileList.length < 5 && (
        <div className="add-box" onClick={handleClickAdd}>
          <span className="plus-icon">
            <PlusIcon />
          </span>
        </div>
      )}
      <input
        type="file"
        accept="image/jpeg,image/png,image/jpg"
        id="hidden-upload"
        style={{ display: "none" }}
        onChange={(e) => {
          const file = e.target.files[0];
          if (file && beforeUpload(file)) {
            setFileList((prev) => [
              ...prev,
              {
                uid: file.uid || file.name,
                name: file.name,
                status: "done",
                originFileObj: file,
                preview: URL.createObjectURL(file),
              },
            ]);
          }
        }}
      />
    </div>
  );

  return (
    <>
      {fileList.length === 0 ? (
        <Dragger
          className="dragger-component"
          beforeUpload={beforeUpload}
          multiple={false}
          showUploadList={false}
          onChange={handleChange}
          onDrop={(e) => {
            const droppedFiles = Array.from(e.dataTransfer.files)
              .filter((file) => beforeUpload(file))
              .map((file) => ({
                uid: file.uid || file.name,
                name: file.name,
                status: "done",
                originFileObj: file,
                preview: URL.createObjectURL(file),
              }));
            setFileList(droppedFiles);
          }}
        >
          <p className="ant-upload-drag-icon">
            <DragIcon />
          </p>
          <p className="ant-upload-text">
            Drag and drop file here or{" "}
            <span className="browse-text">browse</span>
          </p>
          <p className="ant-upload-hint">
            Supported file formats: JPG, PNG, JPEG
          </p>
        </Dragger>
      ) : (
        renderThumbnails()
      )}
    </>
  );
}

export default PhotoDragUpload;
